import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Title = styled.p`
  font-size: 1.25rem;
  font-weight: 500;
`;

export const RequiredFieldsContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`;

export const RequiredFieldsText = styled.span`
  font-weight: 600;
`;

export const RequiredFieldLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  cursor: pointer;

  &[aria-disabled="true"] {
    cursor: default;
  }
`;

export const RequiredFieldInput = styled.input`
  height: 1rem;
  width: 1rem;
  cursor: pointer;
`;

